import {
  type HighlightConfigKey,
  selectViewStateHighlightConfigKey,
  selectViewStateIsPasting,
  selectViewStateIsSavingSettings,
  selectViewStatePageSize,
  selectViewStateViewId,
  useAppSelector,
  type Vmid,
} from '@salescore/client-redux'

import { useVmid } from '../components/VmidContext'

const requireValue = <T>(value: T | undefined, fieldName: string, vmid: Vmid): T => {
  if (value === undefined) {
    throw new Error(`ViewState.${fieldName} is undefined for vmid: ${vmid}`)
  }
  return value
}

export const useViewStateViewId = (): string => {
  const vmid = useVmid()
  const value = useAppSelector((state) => selectViewStateViewId(state, vmid))
  return requireValue(value, 'viewId', vmid)
}

export const useViewStatePageSize = (): number => {
  const vmid = useVmid()
  const value = useAppSelector((state) => selectViewStatePageSize(state, vmid))
  return requireValue(value, 'pageSize', vmid)
}

export const useViewStateIsSavingSettings = (): boolean => {
  const vmid = useVmid()
  const value = useAppSelector((state) => selectViewStateIsSavingSettings(state, vmid))
  return requireValue(value, 'isSavingSettings', vmid)
}

export const useViewStateIsPasting = (): boolean => {
  const vmid = useVmid()
  const value = useAppSelector((state) => selectViewStateIsPasting(state, vmid))
  return requireValue(value, 'isPasting', vmid)
}

export const useViewStateHighlightConfigKey = (): HighlightConfigKey => {
  const vmid = useVmid()
  const value = useAppSelector((state) => selectViewStateHighlightConfigKey(state, vmid))
  return requireValue(value, 'highlightConfigKey', vmid)
}
